import type { FC } from 'react';

import Checkbox from '@/components/UI/FormElements/Checkbox';
import { _isEmpty } from '@/littledash';

import type { ProposedCage } from '../Recaging.utils';

interface SubmitSectionProps {
  loading: boolean;
  studyCagesLoading: boolean;
  submitting: boolean;
  proposedCages: ProposedCage[];
  deleteCages: boolean;
  onDeleteCagesChange: (checked: boolean) => void;
  onSubmit: (deleteCages: boolean) => void;
}

export const SubmitSection: FC<SubmitSectionProps> = ({
  loading,
  studyCagesLoading,
  submitting,
  proposedCages,
  deleteCages,
  onDeleteCagesChange,
  onSubmit,
}) => {
  return (
    <div className="flex items-center w-100 mv3 w-auto-ns mb0-ns">
      <button
        disabled={loading || studyCagesLoading || submitting || _isEmpty(proposedCages)}
        onClick={() => onSubmit(deleteCages)}
      >
        {submitting ? 'Submitting…' : 'Submit'}
      </button>

      <Checkbox
        className={'dib pl3'}
        name="delete-cages"
        label="Delete empty cages in study"
        checked={deleteCages}
        onChange={({ target: { checked } }) => onDeleteCagesChange(checked)}
      />
    </div>
  );
};
